import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en/translation.json";
import no from "../locales/no/translation.json";
import { registerI18nFormatters } from "./common/formatting/i18nFormatters";
import { getPreferredLanguage } from "./common/local-storage/language";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    no: {
      translation: no,
    },
  },
  lng: getPreferredLanguage().toLowerCase(),
  fallbackLng: "en",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

registerI18nFormatters(i18n);

// HMR boundary: absorb translation.json edits in-place so they don't bubble up to main.tsx
// and trigger a full page reload. We re-feed the new bundles into i18next and nudge a
// language change so useTranslation() consumers re-render with the updated strings.
if (import.meta.hot) {
  import.meta.hot.accept(
    ["../locales/en/translation.json", "../locales/no/translation.json"],
    ([nextEn, nextNo]) => {
      if (nextEn) i18n.addResourceBundle("en", "translation", nextEn.default ?? nextEn, true, true);
      if (nextNo) i18n.addResourceBundle("no", "translation", nextNo.default ?? nextNo, true, true);
      void i18n.changeLanguage(i18n.language);
    },
  );
}
